/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var _require = require('../query/GraphQLTag'),
  getUpdatableQuery = _require.getUpdatableQuery;
var _require2 = require('./createUpdatableProxy'),
  createUpdatableProxy = _require2.createUpdatableProxy;
function readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
  var updatableQuery = getUpdatableQuery(query);
  return {
    // $FlowFixMe[incompatible-call]
    updatableData: createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
  };
}
module.exports = {
  readUpdatableQuery: readUpdatableQuery
};